export const HIDE_MONTH_WIDTH = 700;
export const HIDE_WEEK_WIDTH = 520;
export const HIDE_CHART_WIDTH = 360;
